import React from 'react';

const PhoneInput = ({ 
  label, 
  name, 
  value, 
  handleChange, 
  error, 
  required = false, 
  tooltip, 
  placeholder = "7XXXXXXXX"
}) => {
  // Extraire seulement la partie locale du numéro (sans l'indicatif)
  const getLocalNumber = (fullNumber) => {
    if (!fullNumber) return '';
    
    // Si le numéro commence par +221 ou 00221
    if (fullNumber.startsWith('+221')) {
      return fullNumber.substring(4);
    }
    if (fullNumber.startsWith('00221')) {
      return fullNumber.substring(5);
    }
    
    // Si c'est juste le numéro local
    if (fullNumber.startsWith('7') && fullNumber.length <= 9) {
      return fullNumber;
    }
    
    return fullNumber;
  };

  // Traitement du changement de valeur
  const handlePhoneChange = (e) => {
    const localNumber = e.target.value.replace(/\D/g, '');
    
    // Valider que le numéro commence par 7 et a maximum 9 chiffres
    if (localNumber === '' || (localNumber.startsWith('7') && localNumber.length <= 9)) {
      // Construire le numéro complet avec l'indicatif +221
      const fullNumber = localNumber ? `+221${localNumber}` : '';
      
      // Simuler un événement avec le numéro complet
      const syntheticEvent = {
        target: {
          name: name,
          value: fullNumber
        }
      };
      
      handleChange(syntheticEvent);
    }
  };

  return (
    <div className="form-group position-relative">
      <label className="form-label text-start w-100">
        {label}
        {required && <span className="text-danger ms-1">*</span>}
        {tooltip && (
          <span 
            className="ms-2 cursor-pointer text-muted" 
            data-bs-toggle="tooltip" 
            data-bs-placement="top" 
            title={tooltip}
          >
            <i className="bi bi-info-circle-fill"></i>
          </span>
        )}
      </label>
      
      <div className="input-group">
        <span className="input-group-text">+221</span>
        <input
          type="tel"
          className={`form-control ${error ? 'is-invalid' : ''}`}
          placeholder={placeholder}
          value={getLocalNumber(value)}
          onChange={handlePhoneChange}
          maxLength={9}
        />
      </div>
      
      {error && <div className="invalid-feedback d-block text-start">{error}</div>}
    </div>
  );
};

export default PhoneInput;